import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext} from "react";
import {ServiceContext} from "../../context/service";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function GuideForm() {

  const handleOpen = () => setModalOpen(!modalOpen);

  const {
    modalOpen,
    setModalOpen,
  } = useContext(ServiceContext);

  return (
    <>
      <Dialog size="l" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen bg-none">
        <DialogHeader className="bg-gray-800 rounded-t-2xl -mt-4">
          <Typography className="py-4 w-full text-white text-2xl z-10 textCenter">
            مراحل دریافت خدمات
          </Typography>
        </DialogHeader>

        <DialogBody
          className="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-2xl overflow-y-scroll max-h-[530px] md:max-h-screen">
          <div className="grid grid-col w-full px-0 border-l-2">
            <Typography className="mb-4 top-4" variant="h6" color="blue-gray">
              <li className="list-item">
                خدمت با قیمت ثابت:
              </li>
            </Typography>
            <Typography variant="body" color="blue-gray" className="mr-8">
              <li className="list-none">
                {`${persianNumberFormat(1)}_ انتخاب موضوع خدمات`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(2)}_ انتخاب مشاور`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(3)}_ تعیین گرایش خدمات`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(4)}_ ثبت درخواست استعلام قیمت`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(5)}_ ارسال مستندات لازم`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(6)}_ پرداخت`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(7)}_ شروع فرآیند خدمات`}
              </li>
            </Typography>
          </div>
          <div className="grid grid-col w-full px-0">
            <Typography className="mb-4 top-4" variant="h6" color="blue-gray">
              <li>
                خدمت نیازمند استعلام قیمت:
              </li>
            </Typography>
            <Typography variant="body" color="blue-gray" className="mr-8">
              <li className="list-none">
                {`${persianNumberFormat(1)}_ انتخاب موضوع خدمات`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(2)}_ انتخاب مشاور`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(3)}_ تعیین گرایش خدمات`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(4)}_ ثبت درخواست استعلام قیمت`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(5)}_ ارسال مستندات لازم`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(6)}_ دریافت قیمت از مشاور`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(7)}_ پرداخت`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(8)}_ شروع فرآیند خدمت`}
              </li>
            </Typography>
          </div>

        </DialogBody>

        <DialogFooter className="space-x-2 justify-end bg-gray-800 rounded-b-2xl -mb-4">
          <Button variant="text" color="white" onClick={() => {
            setModalOpen(false)
          }}>
            <span>بازگشت</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}
